import { Component, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBase } from 'src/app/_models/form-base';
import { map, Observable, startWith } from 'rxjs';
import { ERROR_MESSAGE } from 'src/app/_helpers/utils';
import {
  MatAutocompleteTrigger,
  MatAutocomplete,
} from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { AsyncPipe } from '@angular/common';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';

interface Option {
  key: string | number;
  value: string;
  options?: string[];
}

@Component({
    selector: 'app-underlined-dropdown-form-field',
    templateUrl: './underlined-dropdown-form-field.component.html',
    styleUrls: ['./underlined-dropdown-form-field.component.scss'],
    imports: [
        MatFormField,
        FormsModule,
        ReactiveFormsModule,
        MatLabel,
        MatSelect,
        MatOption,
        MatError,
        MatInput,
        MatAutocompleteTrigger,
        MatAutocomplete,
        AsyncPipe,
        MatIcon,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnderlinedDropdownFormFieldComponent implements OnInit {
  /** Field form base (required) */
  field = input<FormBase<string>>();

  /** Parent FormGroup containing the control (required) */
  parentForm = input<FormGroup>();

  /** Whether the dropdown is a datalist (optional) */
  isDataList = input<boolean>(false);

  /** Float label (optional) */
  floatLabel = input<boolean>(true);

  /** Tooltip text (optional) */
  tooltipText = input<string | null>(null);

  filteredOptions: Observable<Option[]>;

  ngOnInit() {
    if (this.isDataList()) {
      const form = this.parentForm();
      const f = this.field();
      if (form && f) {
        this.filteredOptions = form.controls[f.key].valueChanges.pipe(
          startWith(''),
          map((value) => this._filter((value as string) || '')),
        );
      }
    }
  }

  private _filter(value: string): Option[] {
    return this.field().options.filter((option) =>
      option.value.toLowerCase().includes(value),
    );
  }

  displayFn(option: Option): string {
    return option?.value;
  }

  public get hasErrors(): boolean {
    const form = this.parentForm();
    const f = this.field();
    if (!form || !f) return false;
    const ctrl = form.controls[f.key];
    return !!(ctrl && ctrl.errors && ctrl.touched);
  }

  public get errorsList(): string[] {
    const form = this.parentForm();
    const f = this.field();
    if (!form || !f) return [];
    const ctrl = form.controls[f.key];
    if (!ctrl || !ctrl.errors) return [];
    return Object.keys(ctrl.errors).map((err: string) => {
      return ERROR_MESSAGE[err](ctrl.getError(err)) as string;
    });
  }
}
